import { z } from 'zod';

export const IterableTrackEventSchema = z.object({
  eventName: z.string(),
  campaignId: z.number().optional(),
  createNewFields: z.boolean().optional(),
  createdAt: z.number().optional(),
  dataFields: z.record(z.string(), z.any()).optional(),
  id: z.string().optional(),
  templateId: z.number().optional(),
});

export type IterableEventsTrack = z.infer<typeof IterableTrackEventSchema>;
